export default "__VITE_ASSET__BTPEMNkL__"